<template>
  <div v-if="isShow" :style="domStyle" ref="removeScoll">
    <!-- 请在此添加代码 -->

    <template>

      <Menu :mode="rowOrCol" :style="firstStyle">
        <template v-for="(item,index) in DataMenu">
          <menu-bar-nav v-if="item.children && item.children.length!==0" :parent-item="item" :secend-style="secendStyle"
            :first-style="firstStyle" v-on:func="clickMenuItem" :key="item.id" :index-par="index" :style="firstStyle"
            :name="item.id">
          </menu-bar-nav>
          <menu-item v-else :name="item.id" :style="firstStyle" :id="item.id" :index="item.index"
            @click.stop.native="clickMenuItem(item.index)">
            <span>{{ item.name }}</span>
          </menu-item>
        </template>
      </Menu>
    </template>
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>
<script>
  //   import MenuBarItem from './fvMenuBarItem.vue';
  var child = {
    template: ` <Submenu :name="parentItem.id" :id="parentItem.id" :index="parentItem.index">
                <template slot="title">
                  
                    <span class="more" @click.stop="treeNavSwitch(parentItem.index)">{{ parentItem.name }}</span>
                </template>
                <template v-for="(item,index) in parentItem.children">
                    <menu-bar-item 
                        v-if="item.children&&item.children.length!==0" 
                        :parent-item="item"
                        :style="SecendStyle"
                        :key="item.id"
                        :index-par="IndexPar"
                        :secend-style="SecendStyle"
                        v-on:func="treeNavSwitch"
                        :name="item.id"
                        
                    >
                    </menu-bar-item>
                    <menu-item v-else :name="item.id" :style="SecendStyle" :id="item.id" :index="item.index" @click.stop.native="treeNavSwitch(item.index)">
                        <span>{{ item.name }}</span>
                    </menu-item>
                </template>
            </Submenu>`,

    props: ["parentItem", "SecendStyle", "FirstStyle", "IndexPar"],
    name: "MenuBarItem",
    data() {
      return {
        index: '',

      }
    },
    mounted() {

    },
    methods: {
      treeNavSwitch(data) {
        this.$emit("func", data);



      }
    },

  }
  import $ from 'jquery';
  require("./lodash.min.js");
  export default {
    name: "MenuBar",
    props: ["primitives", "fvSystemApi", "parentObject"],
    components: {
      "menu-bar-nav": child

    },
    created: function () {
      //组件数据混淆
      this.mixin(this.primitives);
      //组件大小位置初始化
      this.domStyle = {
        position: "absolute",
        left: this.x + "px",
        top: this.y + "px",
        width: this.width + "px",
        height: this.height + "px",
      }
      this.firstStyle = {
        fontSize: this.firstMenu.fontSize + "px",
        color: this.firstMenu.color,
        background: this.firstMenu.bgColor,

      }
      this.secendStyle = {
        color: this.secendMenu.color + "!important",
        fontSize: this.secendMenu.fontSize + 'px',
        background: this.secendMenu.bgColor + "!important",

      }
      this.enableStyle = {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: "0px",
        backgroundColor: "#ccbfbf",
        opacity: "0.5"
      }
      this.modelsPath = this.parentObject.modelsPath.slice(0);
      this.modelsPath.push(this.registerName);
      this.DataMenu = this.MenuData;
      this.$store.registerModule(this.modelsPath, {
        state: {
          $: this
        }
      });
      if (this.Click && this.Click != "%Click%") {
        this.Click = AsyncFunction("index", this.Click);
      }
    },
    mounted: function () {
      if (this.direction == true) {
        this.rowOrCol = "horizontal";
        this.$refs.removeScoll.className = '';
        require('./row.css');
      } else if (this.direction == false) {
        this.rowOrCol = "vertical";
        // $(".ivu-menu-vertical>.ivu-menu-submenu-title>li.ivu-menu-submenu>i").css("display","block !important");

      }
    },
    data: function () {
      return {
        //是否可用
        isEnable: false,
        //是否显示
        isShow: true,
        rowOrCol: "horizontal",
        //组件大小位置,在created(创建完毕，挂载前)函数中初始化
        domStyle: {},
        firstStyle: {},
        secendStyle: {},
        DataMenu: [],
        viewVersion:"10.0.3.3"
      }
    },
    methods: {
      /*
          参数：src 原json数据
          作用：混淆数据到当前对象
      */
      mixin(src) {
        for (var key in src) {
          this[key] = src[key]
        }
      },
      /*
          参数：e 鼠标信息
               domScale 窗口放大、缩小、偏移等信息
          作用：鼠标事件调用函数，无必要可不进行任何处理
      */
      doFixedEvent(e, domScale) {

      },
      //查找json数组里匹配的对象
      find(arr, index) {
        if (arr == null) return null;
        for (let obj of arr) {
          if (obj.index === index) {
            return this.collect(obj);
          }
          let ret = this.find(obj.children, index);
          if (ret) {
            return ret;
          }
        }
        return null;
      },
      collect(obj) {
        let ret = obj;
        if (obj.children) {
          for (let o in obj.children) {
            // ret = {...ret, ...this.collect(o)}
            ret = Object.assign(ret, this.collect(o))
          }
        }
        return ret;
      },

      /*
          参数：无
          作用：系统周期调用
      */
      onTimer() {
        if (this.isEnable) return;
      },
      /*
          参数：无
          作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
      */
      onClose() {
        return new Promise((resolve) => {
          resolve();
        })
      },
      /*
          参数：scaleObj 重绘信息
          作用：组件需要重绘时触发
      */
      reDraw(scaleObj) {
        this.firstStyle.fontSize = parseInt(this.firstMenu.fontSize * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) +
          "px";
        this.secendStyle.fontSize = parseInt(this.secendMenu.fontSize * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) +
          "px";
        this.domStyle.fontSize = parseInt((12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
        this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
        this.domStyle.top = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
        this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
        this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
        let width = parseInt(this.domStyle.width) / this.MenuData.length + 'px';
        let font = parseInt(this.secendMenu.fontSize * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy);
        //产生随机字母 
        this.reloadDraw()

      },
      //生成随机数
      getRanNum() {
        var result = [];
        for (var i = 0; i < 4; i++) {
          var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
          //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
          result.push(String.fromCharCode(65 + ranNum));
        }
        return result.join('');
      },
      /*
          参数：isShow 显示隐藏
          作用：设置组件整体显隐
      */
      Show: function (isShow) {
        this.isShow = isShow ? true : false;
      },
      /*
          参数：isEnable 是否可用
          作用：设置组件是否可用
      */
      Enable: function (isEnable) {
        this.enableStyle.zIndex="7001";
        this.isEnable = isEnable ? false : true;
      },
      guid() {
        return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36);
      },
      clickMenuItem(num) {
        this.onClick(num)
      },
      addMenuItem(num, name) {
        let compare = num.substr(num.length - 1, 1);
        let pretty = this.find(this.DataMenu, num);
        if (num.indexOf("-") != -1 && pretty == null) {
          var indexData = num.substring(0, num.lastIndexOf('-'));
          var addArr = this.find(this.DataMenu, indexData);
          if (addArr.children !== undefined) {
            addArr.children.push({
              "name": name,
              "index": num,
              "id": this.guid()
            });
          } else {
            this.$set(addArr, "children", []); //添加一个属性
            addArr.children.push({
              "name": name,
              "index": num,
              "id": this.guid()
            });
          }

        } else if (num.indexOf("-") == -1 && /^\+?[1-9][0-9]*$/.test(num) == true && pretty == null) {
          this.MenuData.push({
            "name": name,
            "index": num,
            "id": this.guid()
          });
        } else if (pretty !== null) {
          if (confirm("当前位置已存在,确认替换修改吗？")) {
            pretty.name = name;
          }else{
            alert("取消修改");
          }
          
        } else {
          alert("菜单位置输入错误");
        }
        this.$nextTick(function() {	
          this.reloadDraw();
        });
	
      },
      reloadDraw(){
        let ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[0].className += " " + ranNum;
        $("." + ranNum + " div.ivu-select-dropdown").css({

          "background": this.secendMenu.bgColor,
        })
        $("." + ranNum +
          ".ivu-menu-horizontal>li.ivu-menu-submenu>.ivu-select-dropdown>.ivu-menu-drop-list>.ivu-menu-item").append(
          '<style>.' + ranNum +
          '.ivu-menu-horizontal>li.ivu-menu-submenu>.ivu-select-dropdown>.ivu-menu-drop-list>.ivu-menu-item{font-size:' +
          this.secendStyle.fontSize + ' !important}</style>');
        // $(".ivu-menu-horizontal").css({
        //     "width":this.domStyle.width
        // })
        // $("li.ivu-menu-submenu,li.ivu-menu-item").css({"width":width})
        $("." + ranNum +
          ".ivu-menu-vertical .ivu-menu-submenu-title,.ivu-menu-vertical .ivu-menu-submenu,.ivu-menu-vertical .ivu-menu-item"
        ).append('<style>.' + ranNum +
          '.ivu-menu-vertical .ivu-menu-submenu-title,.ivu-menu-vertical .ivu-menu-submenu,.ivu-menu-vertical .ivu-menu-item{width:' +
          this.domStyle.width + ' !important}</style>');
      },
       clean(el) {
        function internalClean(el) {
            return _.transform(el, function (result, value, key) {
                var isCollection = _.isObject(value);
                var cleaned = isCollection ? internalClean(value) : value;

                if (isCollection && _.isEmpty(cleaned)) {
                    return;
                }

                _.isArray(result) ? result.push(cleaned) : (result[key] = cleaned);
            });
        }

        return _.isObject(el) ? internalClean(el) : el;
    },
      deleteMenuItem(num) {
        var removeEl = $(`li[index=${num}]`);
        if (removeEl.length !== 0) {
          let pretty = this.find(this.DataMenu, num);
          for (const key in pretty) {
            this.$delete(pretty,key);
          }
          this.DataMenu = this.clean(this.DataMenu);
        } else {
          alert("想删除的菜单不存在");
        }
      },
      UpDateData (){},
      /*
          参数 : 暂无
          作用： 执行组件事件
      */
      onClick(data) {
        
        if(data.indexOf("-") != -1 ){
          data=parseFloat(data.replace(/-/g, "0"));
        }else{
          data=parseFloat(data);
        }
        if (typeof (this.Click) == "function") {
          this.fvSystemApi.executionScript(this.Click, data);
        }
      },
    }
  }

</script>
<style>
  /* .ivu-menu-vertical{
        
        text-align: center;
    } */
  /* .ivu-menu-vertical .ivu-menu-submenu-title,.ivu-menu-vertical .ivu-menu-submenu,.ivu-menu-vertical .ivu-menu-item{
            /* margin: 0 auto;
            text-align: center; */
  /* padding-left: 0px !important; */
  /* width: 100%; */
  /* padding-right: 0px; */
  /* } */
  .ivu-menu-vertical li {
    white-space: nowrap;
  }

  .ivu-menu-vertical.ivu-menu-light:after {
    display: none;
  }

  .ivu-menuBar-div {
    width: 100%;
    height: 100%;
    position: absolute;
    padding: 0;
    overflow: auto;
  }

  .ivu-menuBar-div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  .ivu-menuBar-div::-webkit-scrollbar {
    height: 6px;
    width: 6px;
    background-color: #F5F5F5;
  }

  .ivu-menuBar-div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(122, 153, 217)), color-stop(0.72, rgb(73, 125, 189)), color-stop(0.86, rgb(28, 58, 148)));
  }

</style>



// WEBPACK FOOTER //
// src/components/primitives/fvMenuBar/fvMenuBar.vue